<template>
    <div>
        <h1>
            Hello General Layout!
        </h1>
    </div>
</template>